import { io } from 'socket.io-client';
import { SOCKET_URL } from '../helper/api_helper';

export const socket = io(SOCKET_URL);
